import { BreadCrumb } from "primereact/breadcrumb";
import React, { useEffect, useState } from "react";
import SplitterImgBox from "../../../../shared/components/SplitterImgBox";
// import AfterImg from "../../../assets/images/afterimg.webp";
// import BeforeImg from "../../../assets/images/beforeimg.webp";
import { Carousel } from "primereact/carousel";
import { ConfirmDialog } from "primereact/confirmdialog"; // For <ConfirmDialog /> component
import { confirmDialog } from "primereact/confirmdialog"; // For confirmDialog method
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchOrderById,
  orderRework,
  updateOrderStatus,
} from "../../../../store/slices/ordersSlice";
import PrimaryButton, {
  OutlinedButton,
} from "../../../../shared/components/CustomButtons";
import { Dialog } from "primereact/dialog";
import { FileUpload } from "primereact/fileupload";
import formValidation from "../../../../utils/validations";
import { CustomInputTextArea } from "../../../../shared/components/AllInputs";
import { getImageUrl, showFormErrors } from "../../../../utils/commonFunctions";
import moment from "moment";

export default function OrderDetail() {
  const dispatch = useDispatch();
  const { id } = useParams();

  const { orderDetails } = useSelector((state) => state.order);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showReworkDialog, setShowReworkDialog] = useState(null);
  const [reworkData, setReworkData] = useState({
    reWorks: [],
    status: "REWORK",
  });

  const [addNewRework, setAddNewRework] = useState({
    beforeImage: "",
    afterImage: "",
    comment: "",
    date: new Date(),
  });

  useEffect(() => {
    dispatch(fetchOrderById(id));
    if (orderDetails) {
      getGroupedPrices();
      if (orderDetails?.reWorks?.length) {
        setReworkData((prev) => ({
          ...prev,
          reWorks: [...orderDetails.reWorks],
        }));
      }
    }
  }, [dispatch, id]);

  const items = [
    { label: "Your Orders", url: "/dashboard/my-orders" },
    { label: "Completed", url: "#" },
    { label: "#" + orderDetails?.id },
  ];

  const responsiveOptions = [
    {
      breakpoint: "1400px",
      numVisible: 1,
      numScroll: 1,
    },
    {
      breakpoint: "1199px",
      numVisible: 1,
      numScroll: 1,
    },
    {
      breakpoint: "767px",
      numVisible: 1,
      numScroll: 1,
    },
    {
      breakpoint: "575px",
      numVisible: 1,
      numScroll: 1,
    },
  ];

  const onPageChange = (e) => {
    setCurrentIndex(e.page);
  };

  const getGroupedPrices = () => {
    // Group items and additionalServices
    const groupedPrices = {};
    orderDetails?.images?.forEach((order) => {
      const combined = [...order.items, ...order.additionalServices];

      combined.forEach(({ name, price }) => {
        if (!groupedPrices[name]) {
          groupedPrices[name] = { name, price: 0, count: 0 };
        }
        groupedPrices[name].price += price;
        groupedPrices[name].count += 1;
      });
    });
    return groupedPrices;
  };

  const imageTemplate = (order) => {
    return (
      <>
        <p
          className="primary-color cursor-pointer text-right"
          onClick={() =>
            downloadBeforeAfterImages(order.beforeImage, order.afterImage)
          }
        >
          <i className="pi pi-download"></i> Download
        </p>
        <SplitterImgBox
          style={{ height: "500px" }}
          BeforeImg={order.beforeImage}
          AfterImg={order.afterImage}
        />
        <div className="flex justify-content-between align-items-end">
          <div className="">
            <p className="font-bold">Room/Area</p>
            <p className="text-gray-color">{order?.area}</p>
          </div>
          <h2>
            {currentIndex + 1}/{orderDetails?.images?.length}
          </h2>
        </div>
      </>
    );
  };

  const approveOrder = () => {
    confirmDialog({
      message: "Are you sure you want to Approve this order?",
      header: "",
      closeIcon: "",
      icon: "pi pi-exclamation-circle text-red-600",
      defaultFocus: "accept",
      acceptClassName: "p-button-danger",
      rejectClassName: "bg-gray-400 border-none",
      accept: () => dispatch(updateOrderStatus({ id, status: "COMPLETED" })),
    });
  };

  const approveReworkConfrimation = () => {
    confirmDialog({
      message: "Are you sure you want to Submit the feedback?",
      header: "",
      closeIcon: "",
      icon: "pi pi-exclamation-circle text-red-600",
      defaultFocus: "accept",
      acceptClassName: "p-button-danger",
      rejectClassName: "bg-gray-400 border-none",
      accept: () =>
        dispatch(
          orderRework({
            id,
            newRework: addNewRework,
            oldReworks: reworkData,
            setVisible: setShowReworkDialog,
          })
        ),
    });
  };

  const newReworkIgnoreFields = ["afterImage"];

  const handleReworkChange = ({ name, value }) => {
    const formErrors = formValidation(
      name,
      value,
      addNewRework,
      newReworkIgnoreFields
    );
    setAddNewRework((prev) => ({ ...prev, [name]: value, formErrors }));
  };

  const handleAddNewReworkFileUpload = (file) => {
    const formErrors = formValidation(
      "beforeImage",
      file,
      addNewRework,
      newReworkIgnoreFields
    );
    return setAddNewRework((prev) => ({
      ...prev,
      beforeImage: file,
      formErrors,
    }));
  };

  const onClickSunmit = () => {
    if (showFormErrors(addNewRework, setAddNewRework, newReworkIgnoreFields)) {
      approveReworkConfrimation();
    }
  };

  const downloadBeforeAfterImages = async (beforeImage, afterImage) => {
    beforeImage = getImageUrl(beforeImage);
    afterImage = getImageUrl(afterImage);

    const downloadImage = async (imageUrl, fileName) => {
      try {
        const response = await fetch(imageUrl, { mode: "cors" });
        if (!response.ok) {
          throw new Error(`Failed to fetch image: ${response.statusText}`);
        }
        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);

        const anchor = document.createElement("a");
        anchor.href = blobUrl;
        anchor.download = fileName;
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);

        // Clean up the blob URL
        URL.revokeObjectURL(blobUrl);
      } catch (error) {
        console.error(`Error downloading image ${fileName}:`, error);
      }
    };

    // Extract file names
    const beforeFileName =
      beforeImage.split("uploads/").pop() || "before-image";
    const afterFileName = afterImage.split("uploads/").pop() || "after-image";

    // Download both images
    await downloadImage(beforeImage, beforeFileName);
    await downloadImage(afterImage, afterFileName);
  };

  return (
    <>
      <div className="menu bg-gray">
        <div className="container">
          <div className="grid gap-4 p-3">
            <BreadCrumb className="bg-transparent border-none" model={items} />
          </div>
        </div>
      </div>
      <div className="container">
        <h1 className="primary-color">Order Details</h1>
        <div className="flex flex-column shadow-2">
          <Carousel
            className="my-order-carousel"
            showIndicators={false}
            showNavigators={true} // Show navigation buttons
            numVisible={1}
            numScroll={1}
            page={currentIndex}
            value={orderDetails?.images || []}
            responsiveOptions={responsiveOptions}
            itemTemplate={imageTemplate}
            onPageChange={onPageChange}
          />
        </div>

        {orderDetails?.isRework ? (
          <div className="mt-4">
            <h1 className="primary-color">Rework Images</h1>
            {orderDetails?.reWorks?.length &&
              orderDetails?.reWorks?.map((rework, index) => {
                return (
                  <div className="flex flex-column shadow-2 mb-3 px-7 py-4">
                    <p
                      className="primary-color cursor-pointer text-right"
                      onClick={() =>
                        downloadBeforeAfterImages(
                          rework?.beforeImage,
                          rework?.afterImage
                        )
                      }
                    >
                      <i className="pi pi-download"></i> Download
                    </p>
                    <SplitterImgBox
                      style={{ height: "500px" }}
                      BeforeImg={rework.beforeImage}
                      AfterImg={rework.afterImage}
                    />
                  </div>
                );
              })}
            <h1 className="primary-color">Client Feedback </h1>

            {orderDetails?.reWorks?.length &&
              orderDetails?.reWorks?.map((rework, index) => {
                return (
                  <div className="flex flex-column shadow-2 py-2 px-7 mb-2">
                    <p className="text-gray-color">{rework?.comment}</p>
                    <h4 className="m-0 mb-2">Images attached</h4>
                    <a
                      className="bg-red-200 w-10rem text-overflow-ellipsis p-3 border-round-3xl text-red-500 cursor-pointer block overflow-hidden"
                      href={getImageUrl(rework?.beforeImage)}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {rework?.beforeImage.split("uploads/")[1]}
                    </a>
                    <p className="text-gray-color">
                      {moment(rework?.date).format("MMMM D, YYYY [at] h:mmA")}
                    </p>
                  </div>
                );
              })}
          </div>
        ) : null}
        <div className="mt-4">
          <h1 className="primary-color">Order Summary</h1>
          <div className="grid px-7 shadow-2">
            <div className="md:col-6">
              <ul className="p-0">
                {orderDetails?.images &&
                  orderDetails?.images?.length &&
                  Object.values(getGroupedPrices())?.map((service, index) => {
                    return (
                      <li
                        key={index}
                        className="flex gap-2 justify-content-between m-0"
                      >
                        <div className="flex gap-3 align-items-center">
                          {service.icon ? (
                            <img src={service.icon} alt={service.name} />
                          ) : null}
                          {service.name} for {service.count} photos
                          <i className="pi pi-info-circle"></i>
                        </div>
                        <p className="font-semibold">
                          ${service.price.toFixed(2)}
                        </p>
                      </li>
                    );
                  })}
              </ul>
              <p className="flex mt-5 text-lg justify-content-between font-semibold">
                <span>Order</span>
                <span>${orderDetails?.totalPrice}</span>
              </p>
            </div>
          </div>
        </div>
        {orderDetails?.status !== "COMPLETED" ? (
          <div className="flex justify-content-center gap-2 mt-8 mb-4">
            <OutlinedButton
              label="Approve"
              extraClassNames="bg-gray-300 text-black-alpha-70 border-none w-full md:w-2"
              onClick={approveOrder}
            ></OutlinedButton>
            <OutlinedButton
              label="Rework"
              extraClassNames="bg-gray-300 text-black-alpha-70 border-none w-full md:w-2"
              onClick={setShowReworkDialog}
            ></OutlinedButton>
          </div>
        ) : null}
      </div>
      <ConfirmDialog />

      <Dialog
        visible={showReworkDialog}
        modal
        breakpoints={{ '960px': '75vw', '641px': '90vw' }}
        style={{ width: '30vw' }}
        onHide={() => {
          if (!showReworkDialog) return;
          setShowReworkDialog(false);
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column px-4 pt-8 pb-4 gap-4 bg-white"
            style={{
              borderRadius: "12px",
            }}
          >
            <div className="bg-red absolute text-center top-0 right-0 w-full text-white py-3 border-round-top-xl">
              Add Comment
            </div>

            <CustomInputTextArea
              placeholder="Write you comment"
              name="comment"
              data={addNewRework}
              extraClassName="w-full"
              rows={5}
              cols={30}
              onChange={handleReworkChange}
            />

            <h4 className="m-0">Upload rework </h4>
            <FileUpload
              mode="basic"
              name="demo[]"
              accept="image/*"
              multiple={false}
              chooseOptions={{
                label: "Upload file",
                icon: "none",
                className: "border-round-xl text-xs",
              }}
              onSelect={(e) => handleAddNewReworkFileUpload(e.files[0])}
            />
            {addNewRework?.formErrors?.beforeImage ? (
              <small className="p-error">
                {addNewRework?.formErrors?.beforeImage}
              </small>
            ) : null}

            <div className="flex justify-content-center gap-2">
              <PrimaryButton
                label="Submit"
                onClick={onClickSunmit}
                extraClassNames="w-4 text-xs"
              ></PrimaryButton>
              <OutlinedButton
                label="Cancel"
                extraClassNames="bg-gray-300 text-black-alpha-70 border-none w-4 text-xs"
                onClick={() => setShowReworkDialog(false)}
              ></OutlinedButton>
            </div>
          </div>
        )}
      ></Dialog>
    </>
  );
}
